import { httpClient } from '@/utils/httpClient';
import type { TransfersShippingType } from './TransfersShippingService';

export interface TransfersShippingLogViewRow {
  id: string;
  entity_identifier: string | null;
  display_name: string | null;
  entity_data: Record<string, unknown> | null;
  status: string | null;
  created_at: string;
  updated_at: string;
  transfer_type: TransfersShippingType | null;
  date_sent: string | null;
  total_quantity: number | null;
}

export interface TransfersShippingLogItemViewRow {
  id: string;
  asset_name: string | null;
  nomenclature: string | null;
  lin: string | null;
  nsn: string | null;
  sent_quantity: number | null;
  asset_ids: string[];
  transfer_shipping_log_id: string;
}

class TransfersShippingLogsService {
  async listLogs(): Promise<TransfersShippingLogViewRow[]> {
    return httpClient.get<TransfersShippingLogViewRow[]>(
      `/api/v1/transfers_shipping_logs_view?order=date_sent.desc`,
    );
  }

  async getLogItems(transferShippingLogId: string): Promise<TransfersShippingLogItemViewRow[]> {
    return httpClient.get<TransfersShippingLogItemViewRow[]>(
      `/api/v1/transfers_shipping_log_items_view?transfer_shipping_log_id=eq.${transferShippingLogId}`,
    );
  }
}

export const transfersShippingLogsService = new TransfersShippingLogsService();
